import { render, staticRenderFns } from "./MpMillionairesQuestion.vue?vue&type=template&id=226d1cd7&scoped=true&"
import script from "./MpMillionairesQuestion.vue?vue&type=script&lang=js&"
export * from "./MpMillionairesQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MpMillionairesQuestion.vue?vue&type=style&index=0&id=226d1cd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d1cd7",
  null
  
)

export default component.exports